import React from 'react';

import TimeUnits from '@swf/components/TimeUnits/TimeUnits';
import { convertMilliseconds } from '@swf/core/utils';

export interface Props {
  time: number;
  count: number;
}

const formatTime = (ms: number) => {
  const time = convertMilliseconds(ms);

  return {
    days: time.days,
    hours: time.hours || '',
    minutes: time.minutes < 10 ? '0' + time.minutes : time.minutes.toString(),
    seconds: time.seconds < 10 ? '0' + time.seconds : time.seconds.toString()
  };
};

const Countdown: React.FC<Props> = ({ time, count }) => {
  const { days, hours, minutes, seconds } = formatTime(Math.abs(time - count));
  if (days) {
    return <TimeUnits days={days} />;
  }

  return (
    <span suppressHydrationWarning>
      {hours ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`}
    </span>
  );
};

export default Countdown;
